import { ModalComponent } from '@vivli/shared/components';
import { useModalApiContext } from '@vivli/core/infrastructure/context';

export const ModalContextWrapper = () => {
    const { modals, dismiss } = useModalApiContext();

    return (
        <>
            {modals
                ?.filter((m) => m.visible)
                .map((modal) => (
                    <ModalComponent onDismiss={dismiss} modal={modal} key={modal.id} />
                ))}
        </>
    );
};
